import React from "react";
import WarehouseGenericSkeleton from "./WarehouseGenericSkeleton";

function WarehouseDetailSkeleton() {
  return (
    <>
      <WarehouseGenericSkeleton />
    </>
  );
}

export default WarehouseDetailSkeleton;
